import React, { useState } from 'react';
import './exp.css';

const Exp = () => {
  const [expandedId, setExpandedId] = useState(0);

  const experiences = [
    {
      id: 0,
      role: 'Data Analyst Intern',
      company: 'American Express',
      period: 'Jan 2026 - Jul 2026',
      description: [
        'Architected an Intelligence Platform, a unified offline analytics platform (Python, Streamlit) with VoC sentiment analytics, operational forecasting, and a 12-chart Data Explorer, 100% on-premise processing for enterprise compliance.',
        'Engineered an automated daily reconciliation pipeline (BigQuery, Qualtrics) achieving 98.7% ingestion success across VoC data feeds; cut failure-detection time ~90% (24 hrs to 12 min) and drove open mismatches to 0.',
        'Built a RAG-based enterprise knowledge assistant grounding LLM responses in curated VoC/ETL documentation via semantic search; cut new-hire ramp-up from days to hours and reduced SME dependency.',
        'Designed and managed end-to-end survey instruments and analysis for major enterprise-wide events, translating stakeholder requirements into structured data collection and actionable insights.',
      ],
      tags: ['Python', 'BigQuery', 'Streamlit', 'RAG', 'NLP'],
    },
    {
      id: 1,
      role: 'Internship Trainee',
      company: 'Amazon ML Summer School',
      period: 'Aug 2025',
      description: [
        'Completed a competitive internship program focused on machine learning and artificial intelligence, gaining hands-on experience with AWS services and ML frameworks.',
      ],
      tags: ['AWS', 'Machine Learning', 'AI'],
    },
    {
      id: 2,
      role: 'Project Intern',
      company: 'Proactive Technologies',
      period: 'May 2025 - Jun 2025',
      description: [
        'Developed a full-stack web application using the MERN stack (MongoDB, Express.js, React, Node.js) and Amazon S3 for cloud storage.',
        'Implemented key e-commerce functionalities including Role-Based Access Control (RBAC), real-time order tracking, customer query management.',
        'Secure invoice viewing to enhance user experience and operational efficiency.',
      ],
      tags: ['MERN Stack', 'Amazon S3', 'RBAC'],
    },
    {
      id: 3,
      role: 'Data Analyst Intern',
      company: 'Cloud Counselage',
      period: 'Jun 2024 - Jul 2024',
      description: [
        'Analyzed large datasets using Python libraries such as Pandas and NumPy to extract actionable insights for business decision-making.',
        'Created interactive data visualizations using Matplotlib and Seaborn to effectively communicate findings to stakeholders.',
      ],
      tags: ['Python', 'Pandas', 'Data Visualization'],
    },
  ];

  return (
    <section className="exp section" id="experience">
      <div className="container">
        <div className="section__header reveal">
          <span className="section__label">Experience</span>
          <h2 className="section__title">Work History</h2>
          <p className="section__subtitle">Professional experiences that shaped my career</p>
        </div>

        <div className="exp__content reveal">
          <div className="exp__tabs">
            {experiences.map((exp) => (
              <button
                key={exp.id}
                className={`exp__tab ${expandedId === exp.id ? 'exp__tab--active' : ''}`}
                onClick={() => setExpandedId(exp.id)}
                id={`exp-tab-${exp.id}`}
              >
                <span className="exp__tab-company">{exp.company}</span>
              </button>
            ))}
          </div>

          <div className="exp__details">
            {experiences.map((exp) => (
              <div
                key={exp.id}
                className={`exp__detail ${expandedId === exp.id ? 'exp__detail--active' : ''}`}
              >
                <div className="exp__detail-header">
                  <h3 className="exp__role">
                    {exp.role} <span className="exp__company">@ {exp.company}</span>
                  </h3>
                  <span className="exp__period">
                    <i className="bx bx-calendar"></i>
                    {exp.period}
                  </span>
                </div>

                <ul className="exp__list">
                  {exp.description.map((item, i) => (
                    <li key={i} className="exp__list-item">
                      <span className="exp__list-arrow">▹</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                <div className="exp__tags">
                  {exp.tags.map((tag, i) => (
                    <span key={i} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Exp;